import { GOOGLE_MAPS_LIBRARIES } from 'constants/googleMapConstants';
import { setGoogleMapsLoadError, setGoogleMapsLoaded } from 'actions/AppActions';
import { useAppSettings } from 'selectors/settingsSelector';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useLoadScript } from '@react-google-maps/api';

interface LoadGoogleMapsState {
  isLoaded: boolean;
  loadError?: Error;
}

// TODO(visgl-burn-in): remove this legacy `useLoadScript` loader (the flag-ON path
// uses MapsApiProvider instead) once CONSUMER_ENABLE_GOOGLE_MAPS_API_UPDATE is fully
// rolled out.
export const useLoadGoogleMaps = (): LoadGoogleMapsState => {
  const settings = useAppSettings();
  const dispatch = useDispatch();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: settings.GOOGLE_MAPS_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    // pinning until https://github.com/JustFly1984/react-google-maps-api/issues/2963 is resolved
    version: '3.47',
  });

  useEffect(() => {
    if (isLoaded) {
      dispatch(setGoogleMapsLoaded(true));
    }
    if (loadError) {
      dispatch(setGoogleMapsLoadError(loadError));
    }
  }, [dispatch, isLoaded, loadError]);
  return { isLoaded, loadError };
};
